import { getTimestamp } from './time';
/**
 * Check Token for OneApp API
 * @param {Date} date
 * @returns {Boolean}
 */
export const isTokenValid = (date) => {
  const todayStamp = getTimestamp(date);
  const expirationStamp = sessionStorage.getItem('clientTokenExpirationDate');
  const clientToken = sessionStorage.getItem('clientToken');
  return (todayStamp <= expirationStamp) && clientToken;
};
